import React from 'react'; 
import SpecificComponent from './SpecificComponent'
import TestChild from './TestChild';

import AppBar from './AppBar'

import { PopupCustom } from './PopupCustom'
import MyPopup from './MyPopup'

import {Grid, TextField, Button} from '@material-ui/core'
import Ws from '../providers/Ws';


export default class Tests extends SpecificComponent{
    constructor(props){
        super(props);
        this.state={
            snak:{
                show:false,
                msg:"Yuhuu",
                succes:true
            }
        }
    }



    componentDidMount(){
        // console.log('Testing dictionary 111 = ', this.dictionary)
        // console.log('Testing userData 111 = ', this.userData)
        // console.log('Testing userPreferences 111 = ', this.userPreferences)
    }

    
    onTestBut = ()=>{

        if(this.state.snak.succes){

            this.setState({
                snak:{ show: true, msg:'Un mesaj de succes',succes:false} 
            })
        }

        else{
            this.setState({
                snak:{ show: true, msg:'Un mesaj de eroare',succes:true} 
            })
        }
    }

    fetchTest = ()=>{
        let WS = new Ws();
        // let c = WS.getData('Angajati/Crud',{t1:"ms"},1);
        // console.log('Test fetch result is = ', c)

        let pO = WS.generatePostObject()

        pO.postDataHeader.Scop = 'Select'
        pO.postDataHeader.Tabela = 'Angajati'
        pO.columns = {c1:'nume', c2:'oras'}
        pO.where = {id:'1'}





        WS.postToJsTruster(pO, null, true)
    }

    render(){
        return (
            <div>
                <AppBar history={this.props.history} title="Tests page" />
                
                {
                    this.state.snak.show &&  <MyPopup snak={this.state.snak} 
                    onTimeout={ ()=>this.setState({  snak:{show:false,msg:'',succes:this.state.snak.succes} }) } />
                }
               

                {/* <PopupCustom 
                    isOpen={this.state.snak.show || false} 
                    isSuccess={this.state.snak.succes || true} 
                    msg={this.state.snak.msg || ''} 
                    handleClose={()=>this.setState({  snak:{show:false,msg:'',succes:true} })}
                /> */}



                Here we can fuck'up things ")"
                <br />
                <TestChild testProp = "BALUBAAAA" />    <br />
                <label>label1 == {this.dictionary.test.label1}</label>

                <br />
                <Button variant="outlined" 
                    className='crm-main-button' 
                    color="primary" 
                    onClick={this.onTestBut}>
                       DO IT !!!
                </Button>

                <br />
                <Button variant="outlined" 
                    className='crm-main-button' 
                    color="primary" 
                    onClick={this.fetchTest}>
                       Test Crud JSTRUSTER!!!
                </Button>
            </div>
        );
    }


}  // end class